import { INJECTION_STATES } from '@/constants/injections/states';
import { ValuesOf } from '@/types/utility';
import { apiInjections } from '@/api/graphql/cloud/injections';
import { apiSamples } from '@/api/graphql/cloud/samples';

type Injection = { state: ValuesOf<typeof INJECTION_STATES> };

export const isInjectionInProgress = (injection: Injection) => {
  return ([
    INJECTION_STATES.PENDING,
    INJECTION_STATES.PREPARING,
    INJECTION_STATES.RUNNING,
    INJECTION_STATES.FINISHING,
  ] as string[]).includes(injection.state);
};

export const isInjectionFailed = (injection: Injection) =>
  injection.state === INJECTION_STATES.FAILED;

export const getProgress = (elapsedTimeMs: number, expectedDurationMs: number): number => {
  const elapsedTimeSec = elapsedTimeMs / 1000;
  const expectedDurationSec = expectedDurationMs / 1000;

  if (expectedDurationSec <= 0) {
    return 0;
  }

  return Math.round((elapsedTimeSec / expectedDurationSec) * 1000) / 1000;
};

export const getProgressTimeFormatted = (
  elapsedTimeMs: number,
  expectedDurationMs: number,
): string => {
  const elapsedTimeSec = elapsedTimeMs / 1000;
  const expectedDurationSec = expectedDurationMs / 1000;
  const durationStr = (elapsedTimeSec / 60).toFixed(2);
  const expectedDurationStr = (expectedDurationSec / 60).toFixed(2);
  return `${durationStr} / ${expectedDurationStr}`;
};

type Device = {
  id: string;
  method_id: string;
  column_id: string;
};

export const startInjection = async (device: Device, vial: string) => {
  const quantity = await apiSamples.getSampleQuantity();
  const sample = await apiSamples.createSample(`Sample ${quantity + 1}`);

  try {
    await apiInjections.startInjection(
      sample.id,
      device.id,
      device.method_id,
      device.column_id,
      vial,
      {},
    );
  } catch (error) {
    await apiSamples.removeSample(sample.id);
    console.error('Failed to start injection:', error);
    throw new Error('Can not start injection');
  }
};
